const NATIONAL_CURRENCY_CODE = 'MXN';

export function normalizeCurrencyCode(
  code: string | null | undefined,
): string {
  return String(code ?? '').trim().toUpperCase();
}

/** True when both legs are non-MXN foreign currencies. */
export function isForeignToForeignCurrencyPair(
  fromCode: string | null | undefined,
  toCode: string | null | undefined,
): boolean {
  const from = normalizeCurrencyCode(fromCode);
  const to = normalizeCurrencyCode(toCode);
  return Boolean(
    from &&
      to &&
      from !== to &&
      from !== NATIONAL_CURRENCY_CODE &&
      to !== NATIONAL_CURRENCY_CODE,
  );
}
